import { useRef } from 'react';

import { getSymbolForKey } from '../../lib/platform';
import { ToastManager } from '../../ToastManager';
import { ContextMenuContent } from '../common/context-menu/ContextMenuContent';
import { DeveloperMenu } from '../common/context-menu/DeveloperMenu';

import { userMeDraftStore } from '../../store/users/UserMeDraftStore.ts';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useFlow } from '../../store/flow/useFlows.ts';
import { useApi } from '../../store/SelectedHomeyStore.hooks.ts';
import { useUserMe } from '../../store/users/useUserMe.ts';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';

export function FlowContextMenuContent(props) {
  const { i18n } = useI18n();
  // const ctx = useContextMenuContext();

  const pendingRef = useRef({
    favorite: false,
  });
  const { api } = useApi();
  const { flow } = useFlow({ flowId: props.flowId });
  const { userMe } = useUserMe();

  const isFavoriteFlow = userMe?.properties.favoriteFlows?.includes(props.flowId) ?? false;

  async function onAction(key) {
    switch (key) {
      case 'trigger':
        props.onTriggerRequest?.();
        break;
      case 'favorite':
        (async () => {
          const favoriteName = `**${flow.name}**`;

          if (pendingRef.current.favorite === true) {
            ToastManager.add({
              message: 'Request still pending, please wait...',
            });
            return;
          }

          if (isFavoriteFlow) {
            try {
              pendingRef.current.favorite = true;

              const nextUserMe = {
                ...userMe,
                properties: {
                  ...userMe.properties,
                  favoriteFlows: (userMe.properties.favoriteFlows ?? []).filter(
                    (id) => id !== props.flowId,
                  ),
                },
              };
              userMeDraftStore.setUserMeDraft({ userMe: nextUserMe });

              await api.users.updateUserMeProperties({
                id: 'favoriteFlows',
                value: nextUserMe.properties.favoriteFlows,
              });

              ToastManager.add({
                icon: glyph.core.heartOutline,
                iconColor: theme.icon.color_light,
                message: i18n.messageFormatter(`flow.removeFavorite`, {
                  name: favoriteName,
                }),
              });
              userMeDraftStore.setUserMeDraftDone();
            } catch (error) {
              userMeDraftStore.setUserMeDraftFailed();
              ToastManager.handleError(error);
            } finally {
              pendingRef.current.favorite = false;
            }

            return;
          }

          try {
            pendingRef.current.favorite = true;

            const nextUserMe = {
              ...userMe,
              properties: {
                ...userMe.properties,
                favoriteFlows: [...(userMe.properties.favoriteFlows ?? []), props.flowId],
              },
            };
            userMeDraftStore.setUserMeDraft({ userMe: nextUserMe });

            await api.users.updateUserMeProperties({
              id: 'favoriteFlows',
              value: nextUserMe.properties.favoriteFlows,
            });

            ToastManager.add({
              icon: glyph.core.heartFill,
              iconColor: theme.color.special_favorite,
              message: i18n.messageFormatter(`flow.addFavorite`, {
                name: favoriteName,
              }),
            });
            userMeDraftStore.setUserMeDraftDone();
          } catch (error) {
            userMeDraftStore.setUserMeDraftFailed();
            ToastManager.handleError(error);
          } finally {
            pendingRef.current.favorite = false;
          }
        })().catch(ToastManager.handleError);
        break;
      default:
        break;
    }
  }

  return (
    <ContextMenuContent.List>
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter(`flow.start`)}
        isDisabled={flow?.triggerable !== true}
        hint={`${getSymbolForKey('alt')} +`}
        icon={glyph.core.mouseButtonLeft}
        onPress={() => {
          onAction('trigger');
        }}
      />

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter(`flow.favorite`)}
        icon={isFavoriteFlow ? glyph.core.heartFill : glyph.core.heartOutline}
        onPress={() => {
          onAction('favorite');
        }}
      />

      <DeveloperMenu onIdRequest={() => flow?.id} onResourceRequest={() => flow} />
    </ContextMenuContent.List>
  );
}
